import { render, staticRenderFns } from "./keepDeclare.vue?vue&type=template&id=15ba0db2&scoped=true"
import script from "./keepDeclare.vue?vue&type=script&lang=js"
export * from "./keepDeclare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ba0db2",
  null
  
)

export default component.exports